/**
 * Fragment de routes du paquet v6-p00-port-depot (vague V6, règle R2 du découpage V4–V11 : un fragment par paquet).
 * Composants chargés à la demande (règle de chargement du registre), aucun code exécuté au chargement.
 * Routes neuves (écrans pleins ; projet par `?projet=`) :
 *  - `/depot/reference?reference=…` (projet-reference-depot-fiche, C9) ;
 *  - `/depot/pipeline?pipeline=…[&environnement=…]` (projet-pipeline-livraison-fiche, C10).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProjetReferenceDepotFiche = lazy(() => import('../ecrans/v6/depot/ProjetReferenceDepotFiche'))
const ProjetPipelineLivraisonFiche = lazy(() => import('../ecrans/v6/depot/ProjetPipelineLivraisonFiche'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v6-depot',
  routes: [
    { chemin: '/depot/reference', element: ecran(ProjetReferenceDepotFiche) },
    { chemin: '/depot/pipeline', element: ecran(ProjetPipelineLivraisonFiche) },
  ],
}
